import React, { Dispatch, SetStateAction } from "react";

interface Props {
  questions: string;
  answers: string;
  active: number;
  setActive: Dispatch<SetStateAction<number>>;
  id: number;
}

const Item = (props: Props) => {
  return (
    <div
      onClick={() => {
        if (props.active === props.id) props.setActive(-1);
        else props.setActive(props.id);
      }}
      className="item"
    >
      <div className="question">
        {props.active === props.id ? "▼" : "▶"} {props.questions}
      </div>
      <div className={props.active === props.id ? "active" : "passive"}>{props.answers}</div>
    </div>
  );
};

export default Item;
